"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseActivityIndicator = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const base_ui_all_1 = require("@unboared/base-ui.all");
const BaseActivityIndicator = ({ infos, style, textStyle, children, }) => (react_1.default.createElement(react_native_1.View, { style: [
        {
            alignItems: 'center',
            justifyContent: 'center',
        },
        style,
    ] },
    react_1.default.createElement(react_native_1.View, null, children),
    react_1.default.createElement(base_ui_all_1.Text, { style: textStyle, text: infos })));
exports.BaseActivityIndicator = BaseActivityIndicator;
//# sourceMappingURL=base_activity_indicator.js.map